import request from '@/utils/request'

// 试题列表
export function examQuestionList(data = {}) {
  return request({
    url: '/api/admin/question/page',
    method: 'post',
    data
  })
}

// 抽题练习-随机获取练习试题
export function getQuestion(data = {}) {
  return request({
    url: '/api/admin/question/getQuestion',
    method: 'post',
    data
  })
}

// 抽题练习-结束练习
export function endExercise(data = {}) {
  return request({
    url: '/api/admin/question/endExercise',
    method: 'post',
    data
  })
}


// 试题详情
export function examQuestionDetails(id) {
  return request({
    url: `/api/admin/question/select/${id}`,
    method: 'post'
  })
}

// 错题列表
export function mistakeQuestionList(data = {}) {
  return request({
    url: '/api/mistake/book/page',
    method: 'post',
    data
  })
}

// 错题练习-获取错误的练习试题
export function getMistakesQuestion(data = {}) {
  return request({
    url: '/api/admin/question/getMistakesQuestion',
    method: 'post',
    data
  })
}

// 错题练习-结束练习
export function endMistakeExercise(data = {}) {
  return request({
    url: '/api/admin/question/endMistakesQuestionExercise',
    method: 'post',
    data
  })
}